<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <div
      class="cf-content cf-content--header-center cf-content--center"
      v-html="generalNotice.body"
    />

    <button
      type="button"
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      @click="$closeModal('generalNotice')"
    >
      Okay
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'GeneralNotice',

    computed: {
      ...mapGetters('content', ['generalNotice'])
    }
  };
</script>
